"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var rest_api_1 = require("@nimles/rest-api");

var actionTypes_1 = require("../actionTypes");

var actionCreator_1 = require("../../utils/actionCreator");

exports.loadClients = function (queryParameters) {
  return actionCreator_1.apiAction({
    type: actionTypes_1.LOAD_CLIENTS
  }, function (_a) {
    var auth = _a.auth;
    return rest_api_1.getClients(auth, queryParameters);
  });
};

exports.loadClient = function (id) {
  return actionCreator_1.apiAction({
    type: actionTypes_1.LOAD_CLIENT,
    id: id
  }, function (_a) {
    var auth = _a.auth;
    return rest_api_1.getClient(auth, id);
  });
};

exports.createClient = function (data) {
  return actionCreator_1.apiAction({
    type: actionTypes_1.CREATE_CLIENT
  }, function (_a) {
    var auth = _a.auth;
    return rest_api_1.postClient(auth, data);
  });
};

exports.updateClient = function (data) {
  return actionCreator_1.apiAction({
    type: actionTypes_1.UPDATE_CLIENT
  }, function (_a) {
    var auth = _a.auth;
    return rest_api_1.putClient(auth, data);
  });
};